import React from 'react';
import * as _ from 'lodash';
import Moment from 'moment';
import splitViewManager from '../utilities/splitViewManager';
import urlParamManger from '../utilities/urlParamManager';
import * as pages from './pageComponents';
import EventManager, { EventType } from '../utilities/EventManager';
import SessionStorageService from '../services/utilities/SessionStorageService';
import Auth from './Auth';
import {
  USER_ROLES,
  PAGE_SIDE,
  API_FLAG,
  REFRESH_UNAPPROVED_WORKS_COUNT_DURATION,
  USER_ROLES_IDS,
  UNAPPROVED_TYPE,
} from '../utilities/constants';
import { isNullOrEmpty } from '../utilities/stringUtil';
import { PermissionConsumer } from '../utilities/PermissionContext';
import {
  isLoginUserPrimaryCompany,
  isTargetRoleId,
} from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';
import WorkScheduleService from '../services/Works';
import { FieldBulletinBoardMenuList } from './FieldBulletinBoardMenuList';

export default class FuncNavi extends React.Component {
  constructor(props) {
    super(props);
    SessionStorageService.removeLastTimeFetchUnapprovedWorksCount();
    SessionStorageService.removeUnapprovedWorksCount();
    this.settingPages = Object.keys(pages.setting); //設定系画面
    this.singlePages = _.concat(pages.singlepages, this.settingPages);
    this.pages = _.merge(pages, pages.setting);
    this.naviRef = null;
    this.isLoginUserPartnerCompany = isTargetRoleId(USER_ROLES_IDS.PARTNER_COMPANY);
    this.usePartnerCompanyApprovalFlag =
      SessionStorageService.getUsePartnerCompanyApprovalFlag() === API_FLAG.On;
    this.needFetchUnapprovedWorkCount =
      this.usePartnerCompanyApprovalFlag &&
      SessionStorageService.getFieldId() &&
      (isLoginUserPrimaryCompany() || this.isLoginUserPartnerCompany);
    //delete this.pages.setting;

    this.state = {
      multiview: true, //マルチビューの状態
      railnavi: SessionStorageService.isOpeningFunctionMenu(), // 開閉状態
      prev_railnavi: SessionStorageService.isOpeningFunctionMenu(),
      page: '', //ページコンポーネント名
      roleId: parseInt(localStorage.getItem('role_id'), 10),
      disabled: false,
      unapprovedWorksCount: {},
      fieldId: SessionStorageService.getFieldId(),
    };

    /**
     * 分割画面のパラメータ
     *
     */
    urlParamManger.setDelegate(urlparam => {
      if (
        //現在と違うページの場合に更新
        urlparam[this.props.vw - 1] &&
        this.state.page.split(':')[0] !=
        urlparam[this.props.vw - 1].split(':')[0]
      ) {
        this.setState({ page: urlparam[this.props.vw - 1] });
        this.loadPage(urlparam[this.props.vw - 1]);
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }
    });

    EventManager.addEventListener(EventType.FULL_SCREAN_MODE, fullscrean => {
      this.setState({ railnavi: !fullscrean });
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  componentDidMount() {
    if (
      this.needFetchUnapprovedWorkCount &&
      Number(this.props.vw) === PAGE_SIDE.left
    ) {
      this.getUnapprovedWorksCount();
      EventManager.addEventListener(EventType.LOAD_PAGE_FUNC_NAVI, page =>
        this.loadPage(page)
      );
      EventManager.addEventListener(
        EventType.REFRESH_UNAPPROVED_WORKS_COUNT,
        this.getUnapprovedWorksCount
      );
    }

    EventManager.addEventListener(EventType.CONFERENCE_MODE, conference => {
      if (conference) {
        this.setState({
          railnavi: false,
          prev_railnavi: this.state.railnavi,
        });
      } else {
        this.setState({
          railnavi: this.state.prev_railnavi,
        });
      }
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  /**
   * サイドメニューの開閉
   * @param {boolean} openingFlag
   */
  naviStatus(openingFlag) {
    this.setState({ railnavi: openingFlag });
    SessionStorageService.setOpeningFunctionMenu(openingFlag);
    EventManager.trigger(EventType.LAYOUT_UPDATE, {});
  }

  /**
   * ページのロード
   * @param { string } page
   */
  loadPage(page) {
    // 現在のpageと選択したpageが違えば処理を行う。同じであればreturn
    if (isNullOrEmpty(page) || page === this.state.page.split(':')[0]) {
      return;
    }

    const now = Moment();
    if (
      this.needFetchUnapprovedWorkCount &&
      now.diff(
        Moment(SessionStorageService.getLastTimeFetchUnapprovedWorksCount()),
        'minutes'
      ) >= REFRESH_UNAPPROVED_WORKS_COUNT_DURATION
    ) {
      this.getUnapprovedWorksCount();
    }

    if (
      _.includes(this.state.page, 'Notifications') &&
      _.isNull(sessionStorage.getItem('field_id'))
    ) {
      this.setState({ disabled: true });
    } else {
      this.setState({ disabled: false });
    }

    let pageParams = page.split(':');

    //シングルページの場合 splitViewManagerに通知
    const regexp = new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp) ? true : false) {
      splitViewManager.forceSingleViewUpdate();
    }

    //設定系画面の場合
    const regexp2 = new RegExp(`^(${this.settingPages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp2) ? true : false) {
      EventManager.trigger(EventType.HIDE_MASTER_MENU, {});
    }

    //ページをコンポーネントをロード
    const _settingPage = _.filter(this.settingPages, settingPage => {
      return settingPage == pageParams[0];
    });
    if (_settingPage.length) {
      this.props.loadSettingPage(Number(this.props.vw))(
        this.pages[pageParams[0]],
        pageParams
      );
    } else {
      this.props.loadPage(Number(this.props.vw))(
        this.pages[pageParams[0]],
        pageParams
      );
    }

    /**
     *TODO urlParamManagerを修正すること
     *同じURLが何度もpushstateされないよう、if文を追加して暫定対応中
     */
    if (pageParams.length === 1 && this.state.page !== page) {
      urlParamManger.setPage(page, this.props.vw);
      this.setState({ page });
      setTimeout(() => {
        EventManager.trigger(EventType.LAYOUT_UPDATE, {});
      }, 1);
    }
  }

  /**
   * 画面分割時反対側のページのロード
   * @param { string } page
   */
  loadPageToOtherSide(page) {
    if (!page) {
      return;
    }

    let pageParams = page.split(':');

    //シングルページの場合 splitViewManagerに通知
    const regexp = new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp) ? true : false) {
      splitViewManager.forceSingleViewUpdate();
    }

    //設定系画面の場合
    const regexp2 = new RegExp(`^(${this.settingPages.join('|')}).*`, 'g');
    if (pageParams[0].split(':')[0].match(regexp2) ? true : false) {
      EventManager.trigger(EventType.HIDE_MASTER_MENU, {});
    }

    //ページをコンポーネントをロード
    // console.log('loadotherside pageparam', pageParams, this.props.vw);
    // this.setState({ page: pageparam[0] });
    const _settingPage = _.filter(this.settingPages, settingPage => {
      return settingPage == pageParams[0];
    });
    if (_settingPage.length) {
      this.props.loadSettingPage(this.pages[pageParams[0]], pageParams);
    } else {
      this.props.loadPage(
        Number(this.props.vw) === PAGE_SIDE.left
          ? PAGE_SIDE.right
          : PAGE_SIDE.left
      )(this.pages[pageParams[0]], pageParams);
    }

    urlParamManger.setPage(
      page,
      Number(this.props.vw) === PAGE_SIDE.left
        ? String(PAGE_SIDE.right)
        : String(PAGE_SIDE.left)
    );
    setTimeout(() => {
      EventManager.trigger(EventType.LAYOUT_UPDATE, {});
    }, 1);
  }

  //1画面判定正規表現
  regexp() {
    return new RegExp(`^(${this.singlePages.join('|')}).*`, 'g');
  }

  //分割メニューの表示非表示
  splitviewMenu() {
    return this.state.page.match(this.regexp())
      ? { display: 'none' }
      : { display: 'flex' };
  }

  // 機能一覧を動作可能状態にする
  enableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'auto';
    this.naviRef.style.opacity = '1';
    this.naviRef.style.cursor = 'pointer';
  }

  // 機能一覧を動作不可能状態にする
  disableNavi() {
    if (!this.naviRef) {
      return;
    }
    this.naviRef.style.pointerEvents = 'none';
    this.naviRef.style.opacity = '.6';
    this.naviRef.style.cursor = 'inherit';
  }

  getUnapprovedWorksCount = () => {
    WorkScheduleService.getUnapprovedCount(this.state.fieldId).then(res => {
      if (res.data) {
        const unapprovedWorksCount = res.data.entities || {};
        this.setState({
          unapprovedWorksCount,
        });
        SessionStorageService.setLastTimeFetchUnapprovedWorksCount(Moment());
        SessionStorageService.setUnapprovedWorksCount(unapprovedWorksCount);
        EventManager.trigger(
          EventType.UPDATE_UNAPPROVED_WORKS_COUNT,
          unapprovedWorksCount
        );
      }
    });
  };

  convertUnapprovedWorkCount = count => {
    const MAX_COUNT = 99;
    if (count > MAX_COUNT) {
      return `${MAX_COUNT}+`;
    }
    return count;
  };

  render() {
    const { unapprovedWorksCount } = this.state;

    const railside = classname => {
      return this.state.railnavi ? `${classname} show` : classname;
    };
    const multiview = classname => {
      return this.state.multiview ? `${classname} selected` : classname;
    };
    const singleview = classname => {
      return !this.state.multiview ? `${classname} selected` : classname;
    };
    const itemSelected = page => {
      if (
        _.size(
          _.filter(this.settingPages, p => {
            return p === this.state.page.split(':')[0];
          })
        ) &&
        page === 'settingPage'
      ) {
        return 'line-list line-list--list select'; //各種設定
      }

      return page === this.state.page.split(':')[0]
        ? 'line-list line-list--list select'
        : 'line-list line-list--list';
    };

    const show_external_service_cooperation_flag = SessionStorageService.getUseLwCooperationFlag() || SessionStorageService.getUseDirectCooperationFlag();

    const renderUnapprovedWorkMenuItem = (
      menuItem,
      partnerUnapprovedWorksCount,
      unapprovedWorksCount
    ) => {
      const valueUnapprovedCount =
        (this.isLoginUserPartnerCompany
          ? partnerUnapprovedWorksCount
          : unapprovedWorksCount) || 0;

      return (
        <li className='list__item'>
          <div
            className={itemSelected(menuItem.name)}
            onClick={() => {
              if (
                isNullOrEmpty(menuItem.name) ||
                menuItem.name === this.state.page.split(':')[0]
              ) {
                return;
              }
              SessionStorageService.setDefaultUnapprovedFilterValue(
                UNAPPROVED_TYPE.UNAPPROVED.value
              );
              EventManager.trigger(EventType.REFRESH_UNAPPROVED_WORKS_COUNT);
              this.loadPage(menuItem.name);
            }}
            // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
            key={_.random(1, true)}
            data-qa='conference_func-navi_field-tree-result'
          >
            <div className='func-navi__nested-menu-icon'>
              {menuItem.getLabel(this.isLoginUserPartnerCompany)}
              <span
                className={
                  valueUnapprovedCount
                    ? 'func-navi__nested-menu-icon--highlight'
                    : ''
                }
              >
                （{this.convertUnapprovedWorkCount(valueUnapprovedCount)}）
              </span>
            </div>
          </div>
        </li>
      );
    };

    return (
      <PermissionConsumer>
        {({ userHasChoseiPermission }) => {
          // rails.jsxのPermissionProviderから受け取る
          if (SessionStorageService.getFieldId() && userHasChoseiPermission) {
            this.enableNavi();
          } else {
            this.disableNavi();
          }
          return (
            <div
              ref={e => {
                this.naviRef = e;
              }}
              id={`func-navi--item${this.props.vw}`}
              className={railside('rail__side')}
            >
              <div className='rail__navi'>
                <div
                  id='func-navi--item1-btn-open'
                  className='btn-rail-navi btn--rail__show'
                  onClick={() => {
                    this.naviStatus(true);
                  }}
                >
                  <i
                    className='i-warrow-right i-2x'
                    style={{ display: this.state.disabled ? 'none' : 'inherit' }}
                    alt='開く'
                    aria-hidden='true'
                  />
                </div>
                <div
                  id='func-navi--item1-btn-close'
                  className='btn-rail-navi btn--rail__hide'
                  onClick={() => {
                    this.naviStatus(false);
                  }}
                >
                  <i
                    className='i-warrow-left i-2x'
                    style={{ display: this.state.disabled ? 'none' : 'inherit' }}
                    alt='閉じる'
                    aria-hidden='true'
                  />
                </div>
              </div>
              <div
                className='rail__menu'
                style={{ display: this.state.disabled ? 'none' : 'inherit' }}
              >
                <div className='func-navi'>
                  <ul className='list list--func-navi'>
                    <h2 className='list__header'>
                      機能一覧
                      <ul
                        className='bar-menu bar-menu--func-navi'
                        style={this.splitviewMenu()}
                      >
                        <li
                          className={singleview(
                            'bar-menu__item sys-splitview-single'
                          )}
                        >
                          <button
                            className='btn-icon btn-icon--bar-menu '
                            onClick={() => {
                              splitViewManager.singleViewUpdate(this.props.vw, true);
                            }}
                            style={{ display: 'none' }}
                          >
                            <i className='i-func1' />
                          </button>
                        </li>
                        <li
                          className={multiview('bar-menu__item sys-splitview-multi')}
                        >
                          <button
                            className='btn-icon btn-icon--bar-menu '
                            onClick={() => {
                              this.loadPageToOtherSide(this.state.page);
                              splitViewManager.multiViewUpdate();
                            }}
                            style={{ display: 'none' }}
                          >
                            <i className='i-func2' />
                          </button>
                        </li>
                      </ul>
                    </h2>
                    <div className='list__scroll'>
                      <li className='list__item'>
                        <div
                          className={itemSelected('Dashboard')}
                          onClick={() => {
                            this.loadPage('Dashboard');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_dashboard'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-home' aria-hidden='true' />
                          </div>
                          ダッシュボード
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('WorkSchedule')}
                          onClick={() => {
                            this.loadPage('WorkSchedule');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_work-schedule'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-schedule-1' aria-hidden='true' />
                          </div>
                          作業予定一覧
                        </div>
                      </li>
                      <Auth approvedRoles={[USER_ROLES.partner, USER_ROLES.foreman]}>
                        <li className='list__item'>
                          <div
                            className={itemSelected('WorkScheduleAll')}
                            onClick={() => {
                              this.loadPage('WorkScheduleAll');
                            }}
                            // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                            key={_.random(1, true)}
                            data-qa='conference_func-navi_work-schedule-all'
                          >
                            <div className='func-navi__nested-menu-icon'>
                              他社予定確認
                            </div>
                          </div>
                        </li>
                      </Auth>

                      <li className='list__item'>
                        <div
                          className={itemSelected('WorkResult')}
                          onClick={() => {
                            this.loadPage('WorkResult');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_work-result'
                        >
                          {/* <div className="line-list line-list--list"> */}
                          <div className='icon icon--line-list'>
                            <i className='i-schedule-2' aria-hidden='true' />
                          </div>
                          作業実績一覧
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('FieldTreeResult')}
                          onClick={() => {
                            this.loadPage('FieldTreeResult');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_field-tree-result'
                        >
                          <div className='func-navi__nested-menu-icon'>
                            入場人数との差異
                          </div>
                        </div>
                      </li>
                      {this.usePartnerCompanyApprovalFlag && (
                        <Auth
                          approvedRoles={[
                            USER_ROLES.prime,
                            USER_ROLES.branch,
                            USER_ROLES.manager,
                            USER_ROLES.partner,
                            USER_ROLES.foreman,
                          ]}
                        >
                          <li className='list__item'>
                            <div
                              className={itemSelected('WorkUnapproved')}
                              // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                              key={_.random(1, true)}
                              data-qa='conference_func-navi_work-result'
                            >
                              <div className='icon icon--line-list'>
                                <i
                                  className='i-list-checks'
                                  aria-hidden='true'
                                />
                              </div>
                              {messageUtility.getMessage('I-001-541')}
                            </div>
                          </li>
                          {renderUnapprovedWorkMenuItem(
                            MENU_ITEM.UNAPPROVED_WORK_SCHEDULE,
                            unapprovedWorksCount.partner_unapproved_schedule_works_count,
                            unapprovedWorksCount.unapproved_schedule_works_count
                          )}
                          {renderUnapprovedWorkMenuItem(
                            MENU_ITEM.UNAPPROVED_WORK_RESULT,
                            unapprovedWorksCount.partner_unapproved_works_count,
                            unapprovedWorksCount.unapproved_works_count
                          )}
                        </Auth>
                      )}
                      <li className='list__item'>
                        <div
                          className={itemSelected('GatePassages')}
                          onClick={() => {
                            this.loadPage('GatePassages');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_gate-passages'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-gate' aria-hidden='true' />
                          </div>
                          ゲート予定
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('CraneUses')}
                          onClick={() => {
                            this.loadPage('CraneUses');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_crane-uses'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-jyuuki' aria-hidden='true' />
                          </div>
                          揚重機予定
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('MachineryUses')}
                          onClick={() => {
                            this.loadPage('MachineryUses');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_machinery-uses'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-kizai' aria-hidden='true' />
                          </div>
                          機材予定
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('ConstructionPlacementPlace')}
                          onClick={() => {
                            this.loadPage('ConstructionPlacementPlace');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_construction-placement-place'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-genbahaitizu' aria-hidden='true' />
                          </div>
                          現場配置計画
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('SafetyDiaries')}
                          onClick={() => {
                            this.loadPage('SafetyDiaries');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_safety-diaries'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-jyunkaikiroku' aria-hidden='true' />
                          </div>
                          巡回記録/各種連絡
                        </div>
                      </li>
                      <li className='list__item'>
                        <div
                          className={itemSelected('ReportSettings')}
                          onClick={() => {
                            this.loadPage('ReportSettings');
                          }}
                          // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                          key={_.random(1, true)}
                          data-qa='conference_func-navi_report-settings'
                        >
                          <div className='icon icon--line-list'>
                            <i className='i-insatsu' aria-hidden='true' />
                          </div>
                          帳票印刷
                        </div>
                      </li>
                      <Auth
                        approvedRoles={[
                          USER_ROLES.prime,
                          USER_ROLES.branch,
                          USER_ROLES.manager,
                        ]}
                      >
                        <li className='list__item'>
                          <div
                            className={itemSelected('settingPage')}
                            onClick={() => {
                              this.loadPage('FieldImages');
                            }}
                            // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                            key={_.random(1, true)}
                            data-qa='conference_func-navi_setting-page'
                          >
                            <div className='icon icon--line-list'>
                              <i className='i-settei' aria-hidden='true' />
                            </div>
                            各種設定
                          </div>
                        </li>
                      </Auth>
                      {show_external_service_cooperation_flag && (
                        <Auth
                          approvedRoles={[
                            USER_ROLES.prime,
                            USER_ROLES.branch,
                            USER_ROLES.manager,
                          ]}
                        >
                          <li className='list__item'>
                            <div
                              className={itemSelected('ExternalServiceCooperation')}
                              onClick={() => {
                                this.loadPage('ExternalServiceCooperation');
                              }}
                              // keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)
                              key={_.random(1, true)}
                              data-qa='conference_func-navi_external-service-cooperation'
                            >
                              <div className='icon icon--line-list'>
                                <i
                                  className='i-external-service-cooperation'
                                  aria-hidden='true'
                                />
                              </div>
                              外部サービス連携
                            </div>
                          </li>
                        </Auth>
                      )}
                      {/* 共通メニュー */}
                      <FieldBulletinBoardMenuList
                        itemSelected={itemSelected('fieldBulletinBoard')}
                      />
                      {/* TODO BLDE_V2-24632で調整会議の機能一覧から通知一覧を削除 リリース後問題なければコメントアウトからソースの削除とする */}
                      {/*<li className='list__item'>*/}
                      {/*<div*/}
                      {/*className={itemSelected('Notifications')}*/}
                      {/*onClick={() => {*/}
                      {/*this.loadPage('Notifications');*/}
                      {/*}}*/}
                      {/*// keyが無いとIEブラウザで画面遷移時にアイコンが消えてしまう(BLDE_V2-19565)*/}
                      {/*key={_.random(1, true)}*/}
                      {/*>*/}
                      {/*<div className='icon icon--line-list'>*/}
                      {/*<i className='i-bell' aria-hidden='true' />*/}
                      {/*</div>*/}
                      {/*通知一覧*/}
                      {/*</div>*/}
                      {/*</li>*/}
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          );
        }}
      </PermissionConsumer>
    );
  }
}

const MENU_ITEM = {
  UNAPPROVED_WORK_SCHEDULE: {
    name: 'WorkScheduleUnapproved',
    getLabel: isPartnerRole =>
      messageUtility.getMessage(isPartnerRole ? 'I-001-545' : 'I-001-546'),
  },
  UNAPPROVED_WORK_RESULT: {
    name: 'WorkResultUnapproved',
    getLabel: isPartnerRole =>
      messageUtility.getMessage(isPartnerRole ? 'I-001-543' : 'I-001-544'),
  },
};



// WEBPACK FOOTER //
// ./src/components/funcNavi.js